import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { Redirect } from 'react-router-dom';
import tokens from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';

import { NetworkTopEpisodesWithRouter } from '../NetworkTopEpisodes';
import { NetworkTopPodcastsWithRouter } from '../NetworkTopPodcasts';
import { trackEvent } from '../../../lib/Tracking';
import { loadNetworkMetadata } from '../../../store/networkMetadata';
import {
  LOADING,
  ERROR,
  UNAUTHORIZED,
  selectNetworkMetadata,
  selectNetworkMetadataStatus,
} from '../../../store/selectors';
import { Helmet } from 'react-helmet';
import { NetworkMetadata, ReduxState } from '../../../types';

const TopEntityContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${tokens.spacer32};

  @media (max-width: 480px) {
    display: block;
  }
`;

type Props = {
  networkId: string;
  status?: 'LOADING' | 'ERROR' | 'UNAUTHORIZED';
  metadata?: NetworkMetadata;
  loadNetworkMetadata: typeof loadNetworkMetadata;
};

export class NetworkLandingPage extends PureComponent<Props> {
  componentDidMount() {
    trackEvent({ category: 'page-type', action: 'view', label: 'network-overview' });
    this.props.loadNetworkMetadata(this.props.networkId);
  }

  render() {
    const { status, networkId, metadata } = this.props;
    switch (status) {
      case LOADING:
        return <span data-qa="network-overview-loading" />;
      case ERROR:
        return <span data-qa="network-overview-error" />;
      case UNAUTHORIZED:
        return <Redirect to="/no-access" />;
      default:
        break;
    }

    if (!metadata) {
      return null;
    }

    return (
      <div data-qa="network-landing-page-container">
        <Helmet title={`Home - ${metadata.name}`} />
        <Type as="h1">{metadata.name}</Type>
        <TopEntityContainer data-qa="network-top-modules">
          <NetworkTopPodcastsWithRouter data-qa="network-top-podcasts" networkId={networkId} />
          <NetworkTopEpisodesWithRouter data-qa="network-top-episodes" networkId={networkId} />
        </TopEntityContainer>
      </div>
    );
  }
}

const selectors = createStructuredSelector<
  ReduxState,
  {
    status: ReturnType<typeof selectNetworkMetadataStatus>;
    metadata: ReturnType<typeof selectNetworkMetadata>;
  }
>({
  status: selectNetworkMetadataStatus,
  metadata: selectNetworkMetadata,
});

const actions = { loadNetworkMetadata };

export const ConnectedNetworkLandingPage = connect(selectors, actions)(NetworkLandingPage);
